import { useMediaQuery } from '@mui/material';
import { DesktopNavbar } from './DesktopNavbar';

export const Navbar: React.FC = () => {
  const isDesktopVariant = useMediaQuery('(min-width: 1025px)');
  return isDesktopVariant
    ? <DesktopNavbar />
    : <></>;
};
